import { Money, MyBooking } from '@/api/MyBooking/myBooking.interfaces';
import { ReducerStatus } from '../types';
import { Type as IconType } from '@ui/components/Icon/Icon.interfaces';

export interface MyBookingState {
    status: ReducerStatus;
    data: MyBooking | null;
    refresh: boolean;
}

export interface MyBookingPaymentStatus {
    hasPaymentRemaining: boolean;
    alreadyPaid: Money | null;
    finalPayment: MyBookingPaymentInfo | null;
    downPayment: MyBookingPaymentInfo | null;
    highlight: MyBookingPaymentHighlight;
}

export interface MyBookingPaymentHighlight {
    finalPaymentDueSoon: boolean;
    downPaymentDueSoon: boolean;
}

export interface MyBookingPaymentInfo {
    amount: Money;
    dueTime: Date;
    hours: number;
    days: number;
}

export enum MyBookingCustomStatus {
    AwaitingCreation = 'AwaitingCreation',
    Confirmed = 'Confirmed',
    ConfirmedAndPaid = 'ConfirmedAndPaid',
    ConfirmedAndAwaiting = 'ConfirmedAndAwaiting',
    Cancelled = 'Cancelled',
}

export interface MyBookingCreated {
    date: Date;
    shortDate: string;
    fullDate: string;
    time: string;
    isToday: boolean;
}

export interface MyBookingBadgeStatus {
    text: string;
    color: string;
    icon?: IconType | null;
    iconTooltip?: string | null;
    refund?: boolean;
}

export interface FlightTicketStatus {
    title: string;
    productText: string;
    color: string;
    description: string | null;
    refund?: boolean;
}
